import { RBAssetEntityType, VodEditorial } from '../../types';

function isVodEditorialItem(item: any): item is VodEditorial {
    return item.entityType === RBAssetEntityType.VodEditorial;
}

export default isVodEditorialItem;
